import { render, staticRenderFns } from "./productPromote.vue?vue&type=template&id=963e2338&scoped=true"
import script from "./productPromote.vue?vue&type=script&lang=js"
export * from "./productPromote.vue?vue&type=script&lang=js"
import style0 from "./productPromote.vue?vue&type=style&index=0&id=963e2338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963e2338",
  null
  
)

export default component.exports